import { render } from "./stock-adjustment-report.vue?vue&type=template&id=01766d6f&scoped=true"
import script from "./stock-adjustment-report.vue?vue&type=script&lang=js"
export * from "./stock-adjustment-report.vue?vue&type=script&lang=js"

import "./stock-adjustment-report.vue?vue&type=style&index=0&id=01766d6f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01766d6f"]])

export default __exports__